module.exports = __webpack_public_path__ + "static/img/step-5.7d380f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step-5.png
// module id = nglt
// module chunks = 1